import Exclusion from '@ps/ds/assets/illustrations/il-exclusion.svg'
import Monitoring from '@ps/ds/assets/illustrations/il-monitoring.svg'
import Preventative from '@ps/ds/assets/illustrations/il-preventative.svg'
import Termidor from '@ps/ds/assets/illustrations/il-termidor.svg'
import TurnService from '@ps/ds/assets/illustrations/il-turn-service.svg'

export const EXCLUSION_PEST_IDS = {
  turnService: 201,
  termidor: 202,
  monitoring: 203,
  preventative: 204,
  exclusion: 205,
} as const

export const PEST_EXCLUSION_TYPES: Record<
  number,
  { label: string; illustration: string; description: string }
> = {
  [EXCLUSION_PEST_IDS.exclusion]: {
    description: 'Seal physical entry points to prevent pest recurrence ',
    illustration: Exclusion,
    label: 'Exclusion Work',
  },
  [EXCLUSION_PEST_IDS.monitoring]: {
    description: 'Active surveillance for early detection',
    label: 'Monitoring',
    illustration: Monitoring,
  },
  [EXCLUSION_PEST_IDS.preventative]: {
    description: 'Prevent infestations before they happen',
    label: 'Preventative',
    illustration: Preventative,
  },
  [EXCLUSION_PEST_IDS.termidor]: {
    description: 'Invisible termiticide to eliminate entire colonies',
    label: 'Termidor',
    illustration: Termidor,
  },
  [EXCLUSION_PEST_IDS.turnService]: {
    description: 'Ensure property is pest-free before the next move in',
    label: 'Turn Service',
    illustration: TurnService,
  },
}

export const PESTS_COVERED_STATUS = {
  RED_BUCKET: 'red-bucket',
  COVERED: 'covered',
  NOT_COVERED: 'not-covered',
  WARRANTY: 'warranty',
  QUOTE_TENANT: 'quote',
  QUOTE_PESTSHARE: 'quote-pestshare',
  PAID_TENANT: 'paid-tenant',
  NEEDS_ADDITIONAL_INFO: 'needs-additional-info',
  REJECTED_BY_TENANT: 'rejected-by-tenant',
  PAID_PM: 'paid-pm',
  EXPIRED_PM: 'expired-pm',
  NEEDS_INFO_TENANT: 'needs-info-tenant',
  REJECTED_PM: 'rejected-pm',
  EXPIRED_TENANT: 'expired-tenant',
} as const

export const COVERAGE_STATUS_ID = {
  [PESTS_COVERED_STATUS.RED_BUCKET]: 1,
  [PESTS_COVERED_STATUS.COVERED]: 2,
  [PESTS_COVERED_STATUS.NOT_COVERED]: 3,
  [PESTS_COVERED_STATUS.WARRANTY]: 4,
  [PESTS_COVERED_STATUS.QUOTE_TENANT]: 5,
  [PESTS_COVERED_STATUS.QUOTE_PESTSHARE]: 6,
  [PESTS_COVERED_STATUS.PAID_TENANT]: 7,
  [PESTS_COVERED_STATUS.NEEDS_ADDITIONAL_INFO]: 8,
  [PESTS_COVERED_STATUS.REJECTED_BY_TENANT]: 9,
  [PESTS_COVERED_STATUS.PAID_PM]: 10,
  [PESTS_COVERED_STATUS.EXPIRED_PM]: 11,
  [PESTS_COVERED_STATUS.NEEDS_INFO_TENANT]: 12,
  [PESTS_COVERED_STATUS.REJECTED_PM]: 13,
  [PESTS_COVERED_STATUS.EXPIRED_TENANT]: 14,
} as const
